export const routes = {
  login: {
    name: "Login",
    url: "/"
  },
  ForgetPassword: {
    name: "Forgot password",
    url: "/forgot-password"
  },
  ResetPasswordSent: {
    name: "ResetPasswordSent",
    url: "/reset-password-sent"
  },
  Orders: {
    name: "Orders",
    url: "/dashboard"
  },
  newOrder: {
    name: "New order",
    url: "/dashboard/orders/new"
  },
  viewOrder: {
    name: "View order",
    url: "/dashboard/orders/"
  },
  Fleet: {
    name: "Fleet",
    url: "/dashboard/fleet"
  },
  Maintenance: {
    name: "Maintenance",
    url: "/dashboard/fleet/maintenance"
  },
  Users: {
    name: "Users",
    url: "/dashboard/users"
  },
  Agents: {
    name: "Agents",
    url: "/dashboard/users/agents"
  },
  Admins: {
    name: "Admins",
    url: "/dashboard/users/admins"
  },
  Analytics: {
    name: "Analytics",
    url: "/dashboard/analytics"
  },
  RevenueAnalytics: {
    name: "RevenueAnalytics",
    url: "/dashboard/analytics/revenue"
  },
  MapAnalytics: {
    name: "MapAnalytics",
    url: "/dashboard/analytics/map"
  },
  KPIsAnalytics: {
    name: "KPIsAnalytics",
    url: "/dashboard/analytics/kpis"
  },
  Warnings: {
    name: "Warnings",
    url: "/dashboard/warnings"
  },
  Settings: {
    name: "Settings",
    url: "/dashboard/settings"
  },
  Template: {
    name: "Template",
    url: "/dashboard/template"
  },
  Revenue: {
    name: "Revenue",
    url: "/dashboard/revenue"
  },
  Map: {
    name: "Map",
    url: "/dashboard/map"
  },
  Kpis: {
    name: "KPIs",
    url: "/dashboard/kpis"
  },
  Warehouse: {
    name: "Warehouse",
    url: "/dashboard/warehouse"
  },
  Stock: {
    name: "Stock",
    url: "/dashboard/warehouse/stock"
  },
  Suppliers: {
    name: "Suppliers",
    url: "/dashboard/warehouse/suppliers"
  },
  SaleOrderDetails: {
    name: "Sale Order Details",
    url: "/dashboard/warehouse/view-sale"
  },
  DepotProfile: {
    name: "Overview",
    url: "/dashboard/depot"
  },
  Finances: {
    name: "Finances",
    url: "/dashboard/finances"
  },

  EBM: {
    name: "EBM",
    url: "/dashboard/ebm"
  },

  Policy: {
    name: "Policy",
    url: "/dashboard/policy"
  },

  Agreements: {
    name: "Agreements",
    url: "/dashboard/policy?page=AGREEMENTS"
  },
  BIIReporting: {
    name: "Issue & Incident",
    url: "/dashboard/bii-reporting"
  },
  NewIssue: {
    name: "New Breakdown",
    url: "/dashboard/bii-reporting/new-issue"
  },
  newReport: {
    name: "New report",
    url: "/dashboard/bii-reporting/new"
  },
  IncidentReport: {
    name: "Incident",
    url: "/dashboard/bii-reporting/incidents"
  },
  TruckHealthSettings: {
    name: "Truck Settings",
    url: "/dashboard/fleet/settings"
  },
  NewTruckInspection: {
    name: "New Inspection",
    url: "/dashboard/fleet/new-inspection"
  },
  shiftReports: {
    name: "Shift Reports",
    url: "/dashboard/fleet/shift-reports"
  },
  energy: {
    name: "Energy",
    url: "/dashboard/energy"
  }
};
